var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "google-map",
    {
      staticClass: "py-31",
      attrs: { center: _vm.center, zoom: _vm.zoom, options: _vm.options }
    },
    [
      _c(
        "google-info-window",
        {
          attrs: {
            options: _vm.infoWindow.options,
            position: _vm.infoWindow.position,
            opened: _vm.infoWindow.open
          },
          on: {
            closeclick: function($event) {
              _vm.infoWindow.open = false
            }
          }
        },
        [
          _c("div", { staticClass: "text-center pt-4 pb-4 px-3" }, [
            _c("p", {
              staticClass: "xsmall font-weight-heavy",
              domProps: { innerHTML: _vm._s(_vm.infoWindow.content.title) }
            }),
            _vm._v(" "),
            _c("p", {
              staticClass: "xxxsmall",
              domProps: { innerHTML: _vm._s(_vm.infoWindow.content.descr) }
            })
          ])
        ]
      ),
      _vm._v(" "),
      _c(
        "gmap-cluster",
        {
          attrs: {
            styles: _vm.clusterStyles,
            "zoom-on-click": true,
            "max-zoom": 2
          }
        },
        _vm._l(_vm.markers, function(marker, index) {
          return _c("google-marker", {
            key: marker.id,
            attrs: { icon: _vm.icon, position: marker.position },
            on: {
              click: function($event) {
                return _vm.toggleInfoWindow(
                  marker.position,
                  { title: marker.title },
                  marker.id
                )
              }
            }
          })
        }),
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }